<template>
  <div class="customl-modal-overlay" v-if="isOpen" @click.self="closeModal">
    <div class="customl-modal-container">
      <!-- Close button -->
      <button class="customl-close-button" @click="closeModal">
        <i class="bx bx-x"></i>
      </button>

      <div class="customl-modal-content">
        <!-- Left column -->
        <div class="customl-left-column">
          <!-- Left column content remains unchanged -->
          <div class="customl-left-column-content">
            <div class="customl-profile-image">
              <img :src="lead.avatar_url || defaultAvatar" alt="Profile picture" />
            </div>

            <div class="customl-status-tag" :class="getStatusClass(lead.status_key)">
              <span class="customl-status-icon">
                <i class="bx bx-check-circle" v-if="lead.status_key === 1"></i>
                <i class="bx bx-pause-circle" v-else-if="lead.status_key === 2"></i>
                <i class="bx bx-x-circle" v-else></i>
              </span>
              {{ getStatusText(lead.status_key) }}
            </div>

            <!-- Other left column items remain unchanged -->
            <div class="customl-status-item">
              <span class="customl-status-icon customl-time">
                <i class="bx bx-time"></i>
              </span>
              <div>
                <div>{{ getTranslations('expression_259') }}:</div>
                <div>{{ lead.created || getTranslations('expression_162') }}</div>
              </div>
              <span class="customl-info-icon">
                <i class="bx bx-info-circle"></i>
              </span>
            </div>
            <!-- Star Rating Component -->
            <div v-if="getChannelObject('id', lead.channel_id)?.parameter?.modules?.survey === 1"
              class="customl-status-item">
              <span class="customl-status-icon customl-rating">
                <i class="bx bx-star"></i>
              </span>
              <div class="customl-display-value">
                <span>{{ getTranslations('expression_165') }}</span>
                <div class="customl-star-rating">
                  <span v-for="n in 5" :key="n" class="customl-star"
                    :class="{ 'customl-star-filled': n <= parsedRating }">
                    <i class="bx" :class="n <= parsedRating ? 'bxs-star' : 'bx-star'"></i>
                  </span>
                </div>
              </div>
            </div>


            <!-- Gender (New Block) -->
            <!-- <div class="customl-status-item">
    <span class="customl-status-icon">
      <i :class="getGenderIconClass(lead.genre_key)"></i>
    </span>
    <span class="customl-text-active">
      {{ getGenderLabel(lead.genre_key) }}
    </span>
  </div> -->


            <!-- @ OU NUMERO DE TELEFONE DE ACORDO COM O TIPO DE CANAL-->
            <div class="customl-status-item">
              <span class="customl-status-icon customl-phone customl-active">
                <!-- <i class="bx bx-phone"></i> -->
                <i :class="identifierAndIconChannelOfLead(lead).icon"></i>
              </span>
              <span class="customl-text-active">{{ identifierAndIconChannelOfLead(lead).identifier_lead }}</span>
            </div>


            <!-- Email  -->
            <div class="customl-status-item">
              <span class="customl-status-icon customl-email ">
                <i class="bx bx-envelope"></i>
              </span>

              <div v-if="editingEmail" class="customl-edit-email-container">
                <div class="customl-input-wrapper">
                  <input v-model="editedEmail" class="customl-input-inline" type="email"
                    placeholder="Digite o novo e-mail" @input="validateEmail" @blur="validateEmail" ref="emailInput" />
                  <div v-if="emailError" class="customl-email-error">
                    <i class="bx bx-error-circle"></i>
                    <span>{{ getTranslations('expression_1386') }}</span>
                  </div>
                </div>
                <div class="customl-edit-actions">
                  <button class="customl-inline-btn customl-save-btn" @click="saveEmailEdit"
                    :disabled="emailError || !editedEmail.trim()"
                    :class="{ 'customl-btn-disabled': emailError || !editedEmail.trim() }">
                    <i class="bx bx-check"></i>
                  </button>
                  <button class="customl-inline-btn customl-cancel-btn" @click="cancelEmailEdit">
                    <i class="bx bx-x"></i>
                  </button>
                </div>
              </div>

              <div v-else class="customl-display-value">
                <span :class="{ 'customl-empty-value': !lead.email }">
                  {{ lead.email ? truncateEmail(lead.email) : getTranslations('expression_143') }}
                </span>
                <button class="customl-inline-btn customl-edit-btn" @click="editEmail">
                  <i class="bx bx-pencil"></i>
                </button>
              </div>
            </div>
            <!-- CHANNEL -->
            <div class="customl-status-item">
              <span class="customl-status-icon customl-channel">
                <i class="bx bx-broadcast"></i>
              </span>
              <span>{{ getChannelObject('id', lead.channel_id).name ? getChannelObject('id', lead.channel_id).name :
                '---' }}</span>
            </div>

            <!-- TIPO DE CHANNEL -->
            <!-- <div class="customl-status-item">
                <span class="customl-status-icon customl-whatsapp">
                    <i :class="identifierAndIconChannelOfLead(lead).icon"></i>
                </span>
                <span>{{ getChannelText(lead.channel_id) }}</span>
              </div>
   -->

            <!-- OPORTUNIDADES -->
            <div class="customl-status-item customl-clickable" @click="navigateTo('opportunities')">
              <div class="customl-clickable-content">
                <span class="customl-status-icon customl-opportunities">
                  <i class="bx bx-bulb"></i>
                </span>
                <span>{{ getTranslations('expression_511') }}</span>
                <span class="customl-arrow-icon">
                  <i class="bx bx-chevron-right"></i>
                </span>
              </div>
            </div>
            <!-- CONVERSAS -->
            <div class="customl-status-item customl-clickable" @click="navigateTo('conversations')">
              <div class="customl-clickable-content">
                <span class="customl-status-icon customl-conversations">
                  <i class="bx bx-message-rounded-dots"></i>
                </span>
                <span>{{ getTranslations('expression_73') }}</span>
                <span class="customl-arrow-icon">
                  <i class="bx bx-chevron-right"></i>
                </span>
              </div>
            </div>

            <!-- WALLETS -->
            <!-- Só aparece se carteira estiver habilitada -->
            <div v-if="isWalletModuleEnabled" class="customl-status-item customl-clickable"
              @click="toggleWalletSection">
              <div class="customl-clickable-content">
                <span class="customl-status-icon customl-wallet">
                  <i class="bx bx-wallet"></i>
                </span>
                <span>{{ getTranslations('expression_152') }}</span>
                <span class="customl-arrow-icon">
                  <i class="bx" :class="showWalletSection ? 'bx-chevron-up' : 'bx-chevron-down'"></i>
                </span>
              </div>
            </div>

          </div>

          <!-- Start conversation button with icon -->
          <button class="customl-start-conversation-btn" @click.prevent="startConversation" data-toggle="modal"
            data-target="#openTicketModal">
            <i class="bx bx-message-square-dots customl-conversation-icon"></i>
            {{ getTranslations('expression_157') }}
          </button>
        </div>

        <!-- Right column -->
        <div class="customl-right-column">
          <div class="customl-contact-name">
            <div class="customl-name-with-edit">
              <!-- Inline name editing -->
              <div v-if="editingName" class="customl-edit-name-container">
                <div class="customl-inline-edit-wrapper">
                  <input v-model="editedName" class="customl-inline-name-edit" type="text"
                    placeholder="Digite o nome do contato" @input="validateName" @blur="validateName" ref="nameInput" />
                  <div class="customl-inline-edit-actions">
                    <button class="customl-inline-edit-btn customl-inline-save-btn" @click="saveNameEdit"
                      :disabled="nameError || !editedName.trim()">
                      <i class="bx bx-check"></i>
                    </button>
                    <button class="customl-inline-edit-btn customl-inline-cancel-btn" @click="cancelNameEdit">
                      <i class="bx bx-x"></i>
                    </button>
                  </div>
                </div>
              </div>

              <!-- Display name when not editing -->
              <div v-else class="customl-display-name">
                <h2>
                  {{ lead.name || getTranslations('expression_234') }}
                  <span v-if="me.data.id === 1" class="customl-lead-id">(#{{ lead.id ||
                    getTranslations('expression_234') }})</span>
                </h2>
                <button class="customl-edit-name-btn" @click="editName" title="Editar nome">
                  <i class="bx bx-edit-alt"></i>
                </button>
              </div>
            </div>

            <!-- Options dropdown menu -->
            <div class="customl-options-dropdown">
              <button class="customl-options-btn" @click="toggleOptionsMenu">
                <i class="bx bx-dots-vertical-rounded"></i>
              </button>

              <div class="customl-dropdown-menu" v-if="showOptionsMenu">
                <div class="customl-dropdown-item" @click="editName">
                  <i class="bx bx-edit"></i>
                  <span>{{ getTranslations('expression_723') }}</span>
                </div>
                <div v-if="me?.data?.role_key === 1 || me?.data?.role_key === 2"
                  class="customl-dropdown-item customl-delete-item" @click="deleteLead(lead)">
                  <i class="bx bx-trash"></i>
                  <span>{{ getTranslations('expression_1160') }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="customl-right-column-scrollable">
            <!-- Enhanced Notes Section -->
            <LeadNotes :lead="lead" />

            <!-- Other sections remain unchanged -->
            <LeadTags :lead="lead" />

            <div class="customl-section">
              <div class="customl-section-header">
                <h3>{{ getTranslations('expression_160') }}</h3>
              </div>


              <div class="newsletter-section">
                <!-- <div class="newsletter-section-header">
                    <h4 class="newsletter-title">Inscrição em Newsletter</h4>
                  </div> -->

                <div class="newsletter-container">
                  <div class="newsletter-icon">
                    <i class="bx bx-envelope"></i>
                  </div>

                  <div class="newsletter-select-wrapper">
                    <select v-model="lead.newsletter_key" @change="updateNewsletterSubscription"
                      class="newsletter-select">
                      <!-- <option :value="null" disabled>Selecione uma newsletter</option> -->
                      <option v-for="newsletter in configs.data.lead_campaigns" :key="newsletter.id"
                        :value="newsletter.id">
                        {{ newsletter.name }}
                      </option>
                    </select>
                    <div class="select-arrow">
                      <i class="bx bx-chevron-down"></i>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <!-- Seção de Campos Personalizados  -->
            <LeadCustomFields :lead-id="lead.id" :channel-id="lead.channel_id" />
            <!-- Seção de Carteira -->
            <WalletSection v-if="isWalletModuleEnabled && showWalletSection" :lead="lead" />


          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import { mapGetters, mapState } from "vuex";
import "../../js/assets/css/modals/ContactModal.css";
import LeadNotes from "../components/leads/LeadNotes.vue";
import LeadTags from "../components/leads/LeadTags.vue";
import WalletSection from '../components/leads/WalletSection.vue';
import LeadCustomFields from "../components/leads/LeadCustomFields.vue";

export default {
  name: 'ContactModal',
  components: {
    LeadNotes,
    LeadTags,
    LeadCustomFields,
    WalletSection
  },
  props: {
    isOpen: {
      type: Boolean,
      default: true
    },
    lead: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      defaultAvatar: require('../assets/img/no-pic-user.png'),
      contact: {},
      showWalletSection: false,
      editingName: false,
      editedName: '',
      nameError: false,
      editingEmail: false,
      editedEmail: '',
      emailError: false,

      loadingCustomFields: false,

      showOptionsMenu: false,

      leadCustomFields: [],
      channelCustomFields: [],
      showEditFieldForm: false,
      editingField: null,
      showAllFields: false,

      rating: 0, // Added for the star rating
    }
  },
  // async mounted() {
  //   // this.fetchContactData(this.lead.id);
  //   if (this.lead?.id && this.lead?.channel_id) {
  //     await this.fetchChannelCustomFields();
  //     await this.fetchLeadCustomFieldValues();
  //   }
  // },
  computed: {
    ...mapState(['lead_tags', 'notes', 'configs', 'wallets', 'me']),
    ...mapGetters([
      'getLeadCampaignsObject',
      'getChannelObject',
      'getLeadTagObject',
      'getLeadTagsArray',
      'getTagsArray',
      'getTranslations',
      'getDepartmentObject',
      'getUserObject',
      'getOperatorObject',
      'getTranslations',
    ]),
    isWalletModuleEnabled() {
      const channel = this.getChannelObject('id', this.lead.channel_id);
      return !!channel?.parameter?.modules?.wallet;
    },
    parsedRating() {
      return this.lead?.tickets_rate_avg_rate
        ? parseInt(this.lead.tickets_rate_avg_rate)
        : 0;
    },


    // Other computed properties remain unchanged
    fieldsWithValues() {
      return this.leadCustomFields.filter(field => field.value && field.value.trim() !== '');
    },

    fieldsWithoutValues() {
      return this.leadCustomFields.filter(field => !field.value || field.value.trim() === '');
    },

    visibleCustomFields() {
      if (this.showAllFields) {
        return this.leadCustomFields.filter(f => !f.hidden); //mostra somente os fields DESARQUIVADOS!
      } else {
        return this.leadCustomFields.filter(f => !f.hidden).slice(0, 2);
      }
    },
    visibleCustomFieldsCount() {
      return this.leadCustomFields.filter(field => !field.hidden).length;
    },

    availableCustomFields() {
      if (!this.channelCustomFields.length) return [];

      return this.channelCustomFields.filter(channelField => {
        return !this.leadCustomFields.some(leadField =>
          leadField.custom_field_id === channelField.id && leadField.value
        );
      });
    },
  },
  methods: {
    getGenderLabel(key) {
      switch (parseInt(key)) {
        case 1:
          return 'Masculino';
        case 2:
          return 'Feminino';
        case 0:
        default:
          return 'Indefinido';
      }
    },
    getGenderIconClass(key) {
      switch (parseInt(key)) {
        case 1:
          return 'bx bx-male-sign text-info'; // ícone masculino
        case 2:
          return 'bx bx-female-sign text-danger'; // ícone feminino
        case 0:
        default:
          return 'bx bx-user text-muted'; // indefinido
      }
    },
    toggleWalletSection() {
      this.showWalletSection = !this.showWalletSection;
    },
    truncateEmail(email) {
      if (!email) return '';


      if (email.length <= 25) return email;


      const parts = email.split('@');
      if (parts.length !== 2) return email;

      const localPart = parts[0];
      const domain = parts[1];


      if (localPart.length > 12) {
        return `${localPart.substring(0, 10)}...@${domain}`;
      }


      if (domain.length > 12) {
        return `${localPart}@${domain.substring(0, 10)}...`;
      }

      return email;
    },
    updateFieldOnBlur(field) {

      this.updateCustomFieldValue(field);
    },
    async updateNewsletterSubscription() {
      try {
        const payload = {
          ...this.lead,
          newsletter_key: this.lead.newsletter_key
        };

        await this.$store.dispatch('updateLead', payload);

        this.$swal.fire({
          icon: 'success',
          title: this.getTranslations('expression_1432'),
          timer: 1500,
          showConfirmButton: false,
          toast: true,
          position: 'bottom-end'
        });
      } catch (error) {
        console.error('Erro ao atualizar inscrição na newsletter:', error);
        this.$swal.fire({
          icon: 'error',
          title: 'Erro',
          text: this.getTranslations('expression_1433'),
          timer: 2000,
          toast: true,
          position: 'bottom-end'
        });
      }
    },
    editName() {
      this.editingName = true;
      this.editedName = this.lead?.name || '';
      this.validateName();
      this.$nextTick(() => {
        this.$refs.nameInput?.focus();
      });
    },

    cancelNameEdit() {
      this.editingName = false;
      this.editedName = this.lead?.name || '';
      this.nameError = false;
    },

    async saveNameEdit() {
      if (this.nameError || !this.editedName.trim()) return;

      try {
        const updatedLead = {
          ...this.lead,
          name: this.editedName.trim()
        };

        await this.$store.dispatch('updateLead', updatedLead);
        await this.$store.dispatch('getLead', { id: this.lead.id });
        this.lead.name = this.editedName.trim();
        this.editingName = false;

        this.$swal.fire({
          icon: 'success',
          title: this.getTranslations('expression_1430'),
          timer: 1500,
          showConfirmButton: false,
          toast: true,
          position: 'bottom-end',
        });
      } catch (error) {
        console.error('Erro ao salvar nome:', error);
        this.$swal.fire({
          icon: 'error',
          title: 'Erro',
          text: this.getTranslations('expression_1431'),
          timer: 2000,
          toast: true,
          position: 'bottom-end',
        });

      }

    },

    validateName() {
      this.nameError = !this.editedName || this.editedName.trim().length < 2;
    },
    editEmail() {
      this.editingEmail = true;
      this.editedEmail = this.lead?.email || '';
      this.validateEmail();

      // Foca no input após a renderização
      this.$nextTick(() => {
        this.$refs.emailInput.focus();
      });
    },

    cancelEmailEdit() {
      this.editingEmail = false;
      this.editedEmail = this.lead?.email || '';
      this.emailError = false;
    },

    validateEmail() {
      if (!this.editedEmail.trim()) {
        this.emailError = false;
        return;
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      this.emailError = !emailRegex.test(this.editedEmail);
    },

    async saveEmailEdit() {
      // verifica novamente a validação antes de salvar
      this.validateEmail();

      // não permite salvar se o email for inválido ou vazio
      if (this.emailError || !this.editedEmail.trim()) {
        return;
      }

      try {
        if (this.editedEmail.trim() && this.editedEmail !== this.lead.email) {
          const updated = { ...this.lead, email: this.editedEmail };
          await this.$store.dispatch('updateLead', updated);

          this.$swal.fire({
            position: 'center',
            icon: 'success',
            title: this.getTranslations('expression_1429'),
            showConfirmButton: false,
            toast: true,
            position: 'bottom-end',
            timer: 1500
          });

          this.lead.email = this.editedEmail;
        }
      } catch (err) {
        console.error('Erro ao atualizar e-mail:', err);
        this.$swal.fire({
          icon: 'error',
          title: 'Erro',
          text: this.getTranslations('expression_1428'),
          timer: 2000,
          toast: true,
          position: 'bottom-end',
        });
      }

      this.editingEmail = false;
    },

    toggleShowAllFields() {
      this.showAllFields = !this.showAllFields;
    },

    async fetchChannelCustomFields() {
      if (!this.lead?.channel_id) return;

      try {
        this.loadingCustomFields = true;
        await this.$store.dispatch("fetchCustomFields", this.lead.channel_id);
        this.channelCustomFields = this.$store.state.customfield.customfields || [];
      } catch (error) {
        console.error("Erro ao carregar campos personalizados do canal:", error);
        this.$swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Falha ao carregar campos personalizados',
          timer: 2000
        });
      } finally {
        this.loadingCustomFields = false;
      }
    },

    async fetchLeadCustomFieldValues() {
      if (!this.lead?.id) return;

      try {
        this.loadingCustomFields = true;
        // busca os valores dos campos personalizados do lead
        const values = await this.$store.dispatch("fetchLeadCustomFieldValues", this.lead.id) || [];

        // combina os campos do canal com os valores do lead
        this.leadCustomFields = this.channelCustomFields.map(field => {
          const leadValue = values.find(v => Number(v.channel_custom_field_id) === Number(field.id));
          return {
            ...field,
            value: leadValue ? leadValue.value : ""
          };
        });
      } catch (error) {
        console.error("Erro ao carregar valores dos campos personalizados:", error);
      } finally {
        this.loadingCustomFields = false;
      }
    },

    editCustomField(field) {
      this.editingField = { ...field };
      this.showEditFieldForm = true;
      this.$nextTick(() => {
        if (this.$refs.editFieldInput) {
          this.$refs.editFieldInput.focus();
        }
      });
    },

    cancelEditField() {
      this.showEditFieldForm = false;
      this.editingField = null;
    },

    async updateCustomFieldValue(field) {
      try {
        await this.$store.dispatch("updateLeadCustomFieldValues", {
          leadId: this.lead.id,
          fields: [
            {
              custom_field_id: field.id,
              value: field.value
            }
          ]
        });

        // Atualiza a lista de campos
        await this.fetchLeadCustomFieldValues();

        // Fecha o formulário de edição se estiver aberto
        if (this.showEditFieldForm) {
          this.showEditFieldForm = false;
          this.editingField = null;
        }

        // Show success notification
        this.$swal.fire({
          icon: 'success',
          title: this.getTranslations('expression_1423'),
          timer: 1500,
          position: 'bottom-end',
          toast: true,
          showConfirmButton: false
        });
      } catch (error) {
        console.error("Erro ao atualizar campo:", error);
        this.$swal.fire({
          icon: 'error',
          title: this.getTranslations('expression_1424'),
          toast: true,
          position: 'bottom-middle',
          showConfirmButton: false,
          text: error.message || this.getTranslations('expression_1426'),
          timer: 2000
        });

        // Revert to previous value if needed
        // field.value = field.previousValue;
      } finally {
        // Clear saving state
        this.$set(field, 'saving', false);
      }
    },
    //     async deleteCustomFieldValue(field) {
    //   try {
    //     const values = await this.$store.dispatch("fetchLeadCustomFieldValues", this.lead.id);
    //     const valueToDelete = values.find(
    //       v => Number(v.channel_custom_field_id) === Number(field.id)
    //     );

    //     if (valueToDelete?.id) {
    //       await this.$store.dispatch("deleteLeadCustomFieldValue", {
    //         leadId: this.lead.id,
    //         valueId: valueToDelete.id
    //       });

    //       // Atualiza visual
    //       await this.fetchLeadCustomFieldValues();

    //       this.$swal.fire({
    //         icon: 'success',
    //         title: 'Valor apagado!',
    //         timer: 1500,
    //         toast: true,
    //         position: 'bottom-end',
    //         showConfirmButton: false,
    //       });
    //     } else {
    //       console.warn('Valor para deletar não encontrado');
    //     }
    //   } catch (error) {
    //     console.error("Erro ao deletar campo:", error);
    //     this.$swal.fire({
    //       icon: 'error',
    //       title: 'Erro',
    //       text: 'Falha ao apagar o valor',
    //       timer: 2000
    //     });
    //   }
    // },

    closeModal() {
      this.$emit('close');
    },

    toggleOptionsMenu() {
      this.showOptionsMenu = !this.showOptionsMenu;
    },

    closeOptionsMenu() {
      this.showOptionsMenu = false;
    },

    toggleTagSelector() {
      this.showTagSelector = !this.showTagSelector;
    },



    fetchContactData(id) {
      // Verifica se o contato já está carregado na store
      if (this.leads && this.leads.lead && this.leads.lead.id === id) {
        this.contact = this.leads.lead;
      } else {
        // Caso não, busca os dados do contato na store
        this.$store.dispatch('getLead', id).then(() => {
          if (this.leads && this.leads.lead) {
            this.contact = this.leads.lead;
            // Após carregar, sincronize as tags com o lead
            this.$store.dispatch('fetchLeadTags', id);
          }
        });
      }
    },
    getStatusText(statusKey) {
      switch (statusKey) {
        case 1:
          return this.getTranslations('expression_138'); // Verificado
        case 2:
          return this.getTranslations('expression_140');
        case 3:
          return this.getTranslations('expression_140'); // Não possui conta
        default:
          return this.getTranslations('expression_142'); // Não Verificado
      }
    },
    getStatusClass(statusKey) {
      switch (statusKey) {
        case 1:
          return 'customl-verified'; // Verde para verificado
        case 2:
          return 'customl-paused'; // Laranja/vermelho para pausado
        case 3:
          return 'customl-no-account'; // Cinza para não possui conta
        default:
          return 'customl-not-verified'; // Amarelo para não verificado
      }
    },
    getChannelText(channelId) {
      const channel = this.getChannelObject('id', channelId);
      if (!channel) return 'Canal desconhecido';

      switch (channel.type_key) {
        case 0:
          return 'WhatsApp';
        case 1:
          return 'Telegram';
        case 2:
          return 'Instagram';
        case 3:
          return 'Messenger';
        default:
          return 'Outro';
      }
    },
    identifierAndIconChannelOfLead(lead) {
      let channel = this.getChannelObject('id', lead.channel_id);
      if (!channel) {
        return { text: '---', icon: 'bx bx-question-mark', identifier_lead: '---' };
      }

      let identifier = lead.phone_hidden || '---';

      switch (channel.type_key) {
        case 0:
          return { text: 'WhatsApp', icon: 'bx bxl-whatsapp', identifier_lead: identifier };
        case 1:
          return { text: 'Telegram', icon: 'bx bxl-telegram', identifier_lead: identifier };
        case 2:
          identifier = lead.username ? `@${lead.username}` : '---';
          return { text: 'Instagram', icon: 'bx bxl-instagram', identifier_lead: identifier };
        case 3:
          return { text: 'Messenger', icon: 'bx bxl-messenger', identifier_lead: identifier };
        default:
          return { text: 'Outro', icon: 'bx bx-help-circle', identifier_lead: identifier };
      }
    }
    ,
    startConversation() {
      this.$store.commit('SET_LEAD_CHECK', {});
      this.$store.commit('SET_TICKET_STEP', 0);

      if (this.lead && this.lead.channel_id > 0 && this.lead.phone.length > 9) {
        this.$store.dispatch('getLeadCheck', this.lead).then(() => {

          // Espera os dados do lead carregarem antes de abrir o modal
          this.$nextTick(() => {
            $('#openTicketModal').modal('show');
          });

        });
        // this.$emit('data-updated');

      }
    },
    // Método para navegação
    navigateTo(route) {
      switch (route) {
        case 'opportunities':
          this.$router.push({
            name: 'Opportunities',
            params: {
              leadId: this.lead.id,
              channel_id: this.lead.channel_id
            }
          });
          break;
        case 'conversations':
          this.$router.push({ name: 'Conversations', params: { leadId: this.lead.id } });
          break;
        default:
        // console.log('Rota não definida');
      }
      this.closeModal();
    },
    async deleteLead(lead) {

      this.closeOptionsMenu();

      const { isConfirmed } = await this.$swal.fire({
        title: this.getTranslations('expression_1159'),
        text: this.getTranslations('expression_311'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: this.getTranslations('expression_421'),
        cancelButtonText: this.getTranslations('expression_355')
      });

      if (!isConfirmed) return;


      try {
        await this.$store.dispatch('deleteLead', {
          id: lead.id,
          params: this.leads.search_lead
        });

        this.closeModal();
        this.$emit('lead-deleted', lead.id);
      } catch (error) {
        console.error('Erro ao excluir lead:', error);
      }
    },



    async handleLeadChange(newVal) {
      if (newVal?.id) {
        this.contact = newVal;

        // if (newVal?.channel_id) {
        //   this.loadingCustomFields = true;
        //   await this.$nextTick();
        //   await this.fetchChannelCustomFields();
        //   await this.fetchLeadCustomFieldValues();
        //   this.loadingCustomFields = false;
        // }
      }
    }
  },
  watch: {
    lead: {
      immediate: true,
      deep: true,
      handler(newVal, oldVal) {

        if (!oldVal || newVal?.id !== oldVal?.id) {
          this.handleLeadChange(newVal);
        }
      }
    }
  },
  mounted() {


    document.addEventListener('click', (e) => {
      if (this.showOptionsMenu && !e.target.closest('.customl-options-dropdown')) {
        this.showOptionsMenu = false;
      }

      if (this.showTagSelector && !e.target.closest('.customl-tag-selector') &&
        !e.target.closest('.customl-add-tag-btn')) {
        this.showTagSelector = false;
      }

      if (this.showEditFieldForm && !e.target.closest('.customl-edit-field-form') &&
        !e.target.closest('.customl-field-edit-icon')) {
        this.showEditFieldForm = false;
        this.editingField = null;
      }
    });
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeOptionsMenu);
  }
}
</script>